"use client";

import { ThemeProvider } from "next-themes";

/**
 * PROVIDERS GLOBAIS DA APLICAÇÃO
 * ==============================
 * 
 * Este componente centraliza todos os "providers" (provedores de contexto)
 * que precisam estar disponíveis em toda a aplicação.
 * 
 * ATUALMENTE INCLUI:
 * - ThemeProvider: gerencia temas claro/escuro automaticamente
 * 
 * CONFIGURAÇÕES DO TEMA:
 * - attribute="class": usa classes CSS para alternar temas
 * - defaultTheme="system": segue a preferência do sistema operacional
 * - enableSystem: permite detecção automática do tema do SO
 * 
 * PARA INICIANTES:
 * - Provider Pattern: padrão React para compartilhar dados entre componentes
 * - Context: permite que componentes filhos acessem dados sem prop drilling
 * - "use client": indica que este componente roda no navegador, não no servidor
 */
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      {children}
    </ThemeProvider>
  );
}
